import { match as lafourcheWeatherMapTab } from "../../../src/params/lafourcheWeatherMapTab.ts";
import { match as organization } from "../../../src/params/organization.ts";
import { match as perms } from "../../../src/params/perms.ts";

export const matchers = { lafourcheWeatherMapTab, organization, perms };